var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 983.82 428.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient-2);\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: url(#New_Gradient_Swatch_36-21);\n      }\n\n      .cls-31 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_36-10);\n      }\n\n      .cls-7 {\n        fill: url(#New_Gradient_Swatch_36-3);\n      }\n\n      .cls-8 {\n        fill: url(#New_Gradient_Swatch_36-12);\n      }\n\n      .cls-9 {\n        fill: url(#New_Gradient_Swatch_36-11);\n      }\n\n      .cls-32 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-10 {\n        fill: url(#New_Gradient_Swatch_36-14);\n      }\n\n      .cls-33 {\n        letter-spacing: 0em;\n      }\n\n      .cls-11 {\n        fill: url(#New_Gradient_Swatch_36-9);\n      }\n\n      .cls-12 {\n        fill: url(#New_Gradient_Swatch_36-19);\n      }\n\n      .cls-13 {\n        fill: url(#New_Gradient_Swatch_36-4);\n      }\n\n      .cls-14 {\n        fill: url(#New_Gradient_Swatch_36-5);\n      }\n\n      .cls-15 {\n        fill: url(#New_Gradient_Swatch_36-6);\n      }\n\n      .cls-16 {\n        fill: url(#New_Gradient_Swatch_36-2);\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-17 {\n        fill: url(#New_Gradient_Swatch_36-18);\n      }\n\n      .cls-18 {\n        fill: #9a5f26;\n      }\n\n      .cls-19 {\n        fill: #b5853e;\n      }\n\n      .cls-20 {\n        fill: url(#New_Gradient_Swatch_36);\n      }\n\n      .cls-21 {\n        fill: url(#New_Gradient_Swatch_36-7);\n      }\n\n      .cls-22 {\n        fill: url(#New_Gradient_Swatch_36-20);\n      }\n\n      .cls-35 {\n        letter-spacing: 0em;\n      }\n\n      .cls-23 {\n        fill: url(#New_Gradient_Swatch_36-16);\n      }\n\n      .cls-36 {\n        fill: #d5bd8f;\n      }\n\n      .cls-24 {\n        fill: #ddc285;\n      }\n\n      .cls-25 {\n        fill: url(#New_Gradient_Swatch_36-15);\n      }\n\n      .cls-26 {\n        fill: url(#New_Gradient_Swatch_36-8);\n      }\n\n      .cls-37 {\n        letter-spacing: 0em;\n      }\n\n      .cls-38 {\n        font-family: BrandonGrotesque-Bold, 'Brandon Grotesque';\n        font-size: 25.99px;\n        font-weight: 700;\n      }\n\n      .cls-27 {\n        fill: url(#New_Gradient_Swatch_36-23);\n      }\n\n      .cls-28 {\n        fill: url(#New_Gradient_Swatch_36-17);\n      }\n\n      .cls-29 {\n        fill: url(#New_Gradient_Swatch_36-22);\n      }\n\n      .cls-30 {\n        fill: url(#New_Gradient_Swatch_36-13);\n      }\n\n      .cls-39 {\n        font-family: BrandonGrotesque-Medium, 'Brandon Grotesque';\n        font-size: 19.49px;\n        font-weight: 500;\n      }\n\n      .cls-40 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.96,
    y1: 214.36,
    x2: 977.86,
    y2: 214.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f3ecd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#be9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f6daa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f3ecd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdaa6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36",
    "data-name": "New Gradient Swatch 36",
    x1: 244.11,
    y1: 81.7,
    x2: 720.76,
    y2: 474.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0d596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#bd9852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e0d596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#bd9852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ffdea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ffffe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ffdea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#bd9852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ffdea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#bd9852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0d596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-2",
    "data-name": "New Gradient Swatch 36",
    x1: 205.64,
    y1: 128.36,
    x2: 682.29,
    y2: 521.36,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-3",
    "data-name": "New Gradient Swatch 36",
    x1: 154.2,
    y1: 190.75,
    x2: 630.85,
    y2: 583.75,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-4",
    "data-name": "New Gradient Swatch 36",
    x1: 198.24,
    y1: 137.34,
    x2: 674.9,
    y2: 530.34,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-5",
    "data-name": "New Gradient Swatch 36",
    x1: 173.25,
    y1: 167.65,
    x2: 649.9,
    y2: 560.65,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-6",
    "data-name": "New Gradient Swatch 36",
    x1: 118.25,
    y1: 234.36,
    x2: 594.9,
    y2: 627.36,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-7",
    "data-name": "New Gradient Swatch 36",
    x1: 145.96,
    y1: 200.75,
    x2: 622.61,
    y2: 593.75,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-8",
    "data-name": "New Gradient Swatch 36",
    x1: 105.22,
    y1: 250.15,
    x2: 581.88,
    y2: 643.15,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-9",
    "data-name": "New Gradient Swatch 36",
    x1: 113.98,
    y1: 239.54,
    x2: 590.63,
    y2: 632.54,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-10",
    "data-name": "New Gradient Swatch 36",
    x1: 120.21,
    y1: 231.98,
    x2: 596.86,
    y2: 624.98,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-11",
    "data-name": "New Gradient Swatch 36",
    x1: 129.72,
    y1: 220.44,
    x2: 606.37,
    y2: 613.44,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-12",
    "data-name": "New Gradient Swatch 36",
    x1: 764.28,
    y1: 71.81,
    x2: 1197.07,
    y2: 426.9,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-13",
    "data-name": "New Gradient Swatch 36",
    x1: 737.77,
    y1: 104.12,
    x2: 1170.56,
    y2: 459.22,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-14",
    "data-name": "New Gradient Swatch 36",
    x1: 695.27,
    y1: 155.92,
    x2: 1128.06,
    y2: 511.01,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-15",
    "data-name": "New Gradient Swatch 36",
    x1: 729.75,
    y1: 113.9,
    x2: 1162.54,
    y2: 468.99,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-16",
    "data-name": "New Gradient Swatch 36",
    x1: 711.94,
    y1: 135.6,
    x2: 1144.73,
    y2: 490.69,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-17",
    "data-name": "New Gradient Swatch 36",
    x1: 673.94,
    y1: 181.92,
    x2: 1106.73,
    y2: 537.01,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-18",
    "data-name": "New Gradient Swatch 36",
    x1: 760.03,
    y1: 76.99,
    x2: 1192.82,
    y2: 432.08,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-19",
    "data-name": "New Gradient Swatch 36",
    x1: 740.09,
    y1: 101.29,
    x2: 1172.88,
    y2: 456.39,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-20",
    "data-name": "New Gradient Swatch 36",
    x1: 706.24,
    y1: 142.55,
    x2: 1139.03,
    y2: 497.64,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-21",
    "data-name": "New Gradient Swatch 36",
    x1: 698.34,
    y1: 152.18,
    x2: 1131.13,
    y2: 507.27,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-22",
    "data-name": "New Gradient Swatch 36",
    x1: 661.08,
    y1: 282.16,
    x2: 1093.88,
    y2: 637.25,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-23",
    "data-name": "New Gradient Swatch 36",
    x1: 672.23,
    y1: 268.58,
    x2: 1105.02,
    y2: 623.67,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 486.99,
    y1: 216.42,
    x2: 487.99,
    y2: 216.42,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "983.17 428.06 983.82 428.71 0 428.71 .65 428.06 983.17 428.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: ".65 428.06 0 428.71 0 0 .65 .65 .65 428.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "983.17 .65 983.82 0 983.82 428.71 983.17 428.06 983.17 .65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: ".65 .65 0 0 983.82 0 983.17 .65 .65 .65"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m977.86,10.75v-3.59c0-.66-.53-1.19-1.19-1.19h-3.59c-.66,0-1.19.53-1.19,1.19v1.19h-1.17v-1.19c0-.66-.53-1.19-1.19-1.19H14.3c-.66,0-1.19.53-1.19,1.19v1.19h-1.17v-1.19c0-.66-.53-1.19-1.19-1.19h-3.59c-.66,0-1.19.53-1.19,1.19v3.59c0,.66.53,1.19,1.19,1.19h1.19v1.17h-1.19c-.66,0-1.19.53-1.19,1.19v401.3h2.38v1.17h-2.38v5.97h5.97v-2.38h1.17v2.38h957.6v-2.38h1.17v2.38h5.97v-5.97h-2.38v-1.17h2.38V14.3c0-.66-.53-1.19-1.19-1.19h-1.19s0-1.17,0-1.17h1.19c.66,0,1.19-.53,1.19-1.19Zm-4.76-1.19h1.17v1.17h-1.17v-1.17ZM11.94,11.94h1.17s0,1.17,0,1.17h-1.17v-1.17Zm-4.76-1.21v-2.36c0-.66.53-1.19,1.19-1.19h2.36v1.17h-1.19c-.66,0-1.19.53-1.19,1.19v1.19h-1.17Zm3.55-1.17v1.17h-1.17v-1.17h1.17Zm0,411.98h-3.55v-3.55h1.17v2.38s2.38,0,2.38,0v1.17Zm0-2.38h-1.17v-1.17h1.17v1.17Zm961.16-2.38h-1.17v-1.17h1.17s0,1.17,0,1.17Zm4.76,1.21v3.55h-3.55v-1.17h2.38s0-2.38,0-2.38h1.17Zm-3.55,1.17v-1.17h1.17v1.17h-1.17Zm3.55-403.65v398.88h-2.38v2.38h-1.17v-2.38h-3.59v3.59h2.38v1.17h-2.38v2.38H14.32v-2.38h-2.38v-1.17h2.38v-3.59h-3.59v2.38h-1.17s0-2.38,0-2.38h-2.38s0-398.88,0-398.88c0-.66.53-1.19,1.19-1.19h0c.66,0,1.19-.53,1.19-1.19v-1.19h1.17v1.19c0,.66.53,1.19,1.19,1.19h1.21c.66,0,1.19-.53,1.19-1.19v-1.21c0-.66-.53-1.19-1.19-1.19h-1.19s0-1.17,0-1.17h1.19c.66,0,1.19-.53,1.19-1.19h0c0-.66.53-1.19,1.19-1.19h952.8c.66,0,1.19.53,1.19,1.19h0c0,.66.53,1.19,1.19,1.19h1.19s0,1.17,0,1.17h-1.19c-.66,0-1.19.53-1.19,1.19v1.21c0,.66.53,1.19,1.19,1.19h1.21c.66,0,1.19-.53,1.19-1.19v-1.19h1.17v1.19c0,.66.53,1.19,1.19,1.19h0c.66,0,1.19.53,1.19,1.19ZM11.94,416.78v-1.17h1.17v1.17h-1.17ZM971.88,11.94v1.17h-1.17v-1.17h1.17Zm1.21-3.59v-1.17h2.36c.66,0,1.19.53,1.19,1.19v2.36h-1.17v-1.19c0-.66-.53-1.19-1.19-1.19h-1.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m425.25,249.27h-89.84c-1.6,0-2.9-1.3-2.9-2.9v-104.73c0-1.6,1.3-2.9,2.9-2.9h89.84c1.6,0,2.9,1.3,2.9,2.9v104.73c0,1.6-1.3,2.9-2.9,2.9Zm0-2.9v1.45-1.45h0Zm-89.84-104.73v104.73h89.84v-104.73s-89.84,0-89.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m438.99,289.35h-117.9c-1.6,0-2.9-1.3-2.9-2.9v-28.59c0-1.6,1.3-2.9,2.9-2.9h117.9c1.6,0,2.9,1.3,2.9,2.9v28.59c0,1.6-1.3,2.9-2.9,2.9Zm0-2.9v1.45-1.45h0Zm-117.9-28.59v28.59h117.89v-28.59s-117.89,0-117.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m328.94,373.65h-11.32l.45-78.89h20.68l-9.8,78.89Zm-8.41-2.9h5.85l9.09-73.1h-14.52l-.41,73.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m442.9,373.65h-11.32l-9.81-78.89h20.68l.45,78.89Zm-8.76-2.9h5.85l-.41-73.1h-14.52l9.09,73.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 269.27,
    y: 257.4,
    width: 29.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 269.27,
    y: 369.46,
    width: 29.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 282.42,
    y: 260.14,
    width: 2.9,
    height: 108.63
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m164.68,318.24v-3.61l15.64-19.03c.13-.13.35-.26.65-.26h2.35c.43,0,.82.35.82.82v18.51h3.48c.48,0,.83.35.83.78v2.69c0,.43-.35.83-.83.83h-3.48l.04,5.56c0,.43-.39.82-.82.82h-3.61c-.43,0-.83-.39-.83-.82v-5.48h-13.43c-.48,0-.83-.39-.83-.83Zm14.43-3.69v-10.43l-8.69,10.43h8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m191.53,320.84l2.21-2.13c.39-.35.78-.35,1.13,0,.13.17,2.69,2.35,5.34,2.35,2.35,0,4.61-1.69,4.61-4.08,0-2.26-2.09-4.3-6-4.3h-2.43c-.48,0-.83-.35-.83-.87v-2.74c0-.57.3-.87.83-.87h2.43c3.56,0,5.39-1.78,5.39-4,0-2.39-2-4-4.21-4s-3.65,1.22-4.39,2.09c-.3.35-.78.39-1.17.04l-2.13-2c-.35-.3-.31-.82,0-1.13,0,0,3.3-3.82,8.17-3.82s9.25,3.08,9.25,7.95c0,3.35-2.52,5.87-4.48,6.78v.13c2.04.87,5.26,3.21,5.26,7.08,0,4.91-4,8.47-9.99,8.47-5.43,0-8.08-2.74-9.04-3.87-.26-.3-.22-.78.04-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m223.12,307.55c2.69,0,4.78,1.09,6.43,3.08.3.39.22.91-.22,1.22l-2,1.91c-.39.35-.78.13-1.09-.13-.7-.78-1.78-1.39-3-1.39-2.35,0-4.26,2-4.26,4.43s1.87,4.43,4.21,4.43c1.87,0,2.69-.91,3.48-1.65.3-.3.74-.39,1.09-.13l1.87,1.61c.43.35.61.78.3,1.22-1.48,2.3-3.78,3.65-6.87,3.65-4.91,0-9.21-3.91-9.21-9.12s4.39-9.12,9.25-9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m233.72,308.81c0-.48.39-.82.83-.82h1.61c.39,0,.65.22.74.48l.61,1.65c.74-.83,2.74-2.56,5.82-2.56,2.48,0,4.21.95,5.65,2.69.74-.78,3-2.69,6.13-2.69,5.56,0,7.6,4.13,7.6,8.69v8.3c0,.43-.35.82-.83.82h-3.52c-.48,0-.83-.39-.83-.82v-8.6c0-2.26-1.09-3.69-3.26-3.69-2.52,0-3.65,1.82-3.65,1.82,0,0,.04.87.04,1.65v8.82c0,.43-.39.82-.82.82h-3.26c-.48,0-.83-.39-.83-.82v-8.6c0-2.26-1-3.69-3.21-3.69s-3.21,1.56-3.65,2.74v9.56c0,.43-.39.82-.83.82h-3.52c-.43,0-.83-.39-.83-.82v-15.73Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m875.63,187.57c-13.46,0-24.41-10.95-24.41-24.41s10.95-24.41,24.41-24.41,24.41,10.95,24.41,24.41-10.95,24.41-24.41,24.41Zm0-46.15c-11.99,0-21.74,9.75-21.74,21.74s9.75,21.74,21.74,21.74,21.74-9.75,21.74-21.74-9.75-21.74-21.74-21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m852.57,240.52c-4.74,0-10.65-2.6-14.74-6.7-5.17-5.18-7.03-12.1-5.24-19.48,4.46-18.39,16.71-22.2,20.36-22.93,3.33-.67,44.67-1,47.48.06,2.19.82,7.99,3,12.96,11.55,6.28,10.81,8.32,17.68,6.63,22.29-1.85,5.03-8.48,12.84-14.24,13.15-5.09.26-21.4-1.51-29.57-7-8.77,5.45-15.22,7.36-21.12,8.79-.78.19-1.63.28-2.52.28Zm25.33-47.07c-11.04,0-22.53.19-24.42.57-3.26.65-14.21,4.09-18.29,20.95-2,8.27,1.36,13.79,4.54,16.97,4.67,4.68,11.16,6.57,14.75,5.71,7.55-1.82,16.04-4.47,29.53-14.91,11.38-8.8,21.81-15.56,25.14-17.67-1.17-1.68-4.3-4.78-10.69-3.22-6.82,1.66-18.34,7.74-25.96,11.76-3.07,1.62-5.49,2.9-6.98,3.57l-.18.08c-5.3,2.38-9.87,4.44-14.14-.13-3.64-3.91-10.23-12-10.51-12.34-.45-.55-.38-1.36.15-1.84.22-.19,5.38-4.65,15.13-1.58,9.18,2.88,17.67,7.75,18.03,7.95l-.4.7c7.61-4,17.78-9.19,24.23-10.76,5.26-1.28,8.81.09,11.07,1.81-3.86-5.03-7.76-6.49-9.39-7.1-1.32-.34-11.27-.51-21.6-.51Zm.79,36.41c7.61,4.45,21.93,6.21,26.95,5.93,4.14-.22,10.09-6.56,11.88-11.4,1.75-4.75-2.81-13.63-5.41-18.24-.11.2-.27.38-.48.51-.12.08-12.38,7.67-26,18.2-2.47,1.91-4.78,3.56-6.94,5.01Zm-35-25.61c1.98,2.42,6.67,8.08,9.46,11.07,2.84,3.04,5.6,1.99,11.1-.48l.18-.08c1.41-.64,3.92-1.96,6.83-3.5.12-.06.24-.13.37-.19-2.54-1.38-9.38-4.92-16.46-7.14-5.92-1.86-9.74-.59-11.48.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m894.82,373.65c-.18,0-.36,0-.55-.01-6.28-.25-12.63-6.56-13.84-10.69-.94-3.19.29-12.56,1.71-23.4.38-2.94.77-5.91,1.12-8.78,1.51-12.52,3.97-40.17,3.97-45.88,0-4.58-7.6-7.08-11.51-7.08-3.63,0-7.39.43-10.31,3.56-2.49,2.66-1.7,13.64-.94,24.26l.19,2.63c.54,7.72,2.82,22.48,4.64,34.33,1.14,7.42,2.04,13.28,2.22,15.45.5,6.23-5.59,12.76-11.36,14.44-5.88,1.71-13.64-1.57-16.41-4.58-3.38-3.69-5.86-29.82-6.54-37.75-1.35-15.77-3.1-43.58-2.66-49.57.43-5.85,9.52-23.95,10.84-26.56v-15.84h2.67v16.16c0,.21-.05.42-.15.61-2.86,5.6-10.35,21.15-10.7,25.83-.43,5.86,1.31,33.46,2.65,49.14,1.63,19.04,4.09,34.26,5.85,36.17,2.28,2.49,9.03,5.19,13.69,3.83,4.69-1.37,9.84-6.76,9.45-11.67-.17-2.07-1.11-8.18-2.2-15.26-1.83-11.91-4.12-26.72-4.67-34.55l-.19-2.63c-1.01-14.11-1.47-22.92,1.65-26.27,3.62-3.88,8.23-4.41,12.26-4.41,4.79,0,14.17,2.94,14.17,9.74,0,5.94-2.45,33.42-3.99,46.2-.35,2.87-.74,5.86-1.13,8.81-1.27,9.66-2.58,19.65-1.8,22.3.98,3.33,6.47,8.59,11.39,8.78,4.7.19,11.77-2.99,12.57-8.6.8-5.55,7.29-59.9,7.29-70.41,0-9.01-1.79-16.39-5.82-23.94-3.52-6.6-6.42-12.84-6.45-12.9-.08-.18-.13-.38-.12-.58l.22-17.04,2.67.03-.22,16.74c.59,1.27,3.19,6.75,6.26,12.5,4.24,7.95,6.13,15.72,6.13,25.19,0,10.61-6.52,65.22-7.32,70.79-.94,6.55-8.41,10.89-14.77,10.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m832.58,213l-.04-.66c-.26-3.77-.75-10.8,1.04-13.48,1.87-2.81,10.92-4.53,11.94-4.71l.24,1.31c-2.63.48-9.75,2.16-11.07,4.14-1.54,2.3-1.05,9.29-.82,12.65l.05.66-1.33.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m846.52,252.35c-3.6,0-6.96-2.85-8.38-7.1-1.33-3.99-3.26-15.54-3.34-16.04l1.31-.22c.02.12,2,11.94,3.29,15.83,1.23,3.7,4.09,6.18,7.11,6.18v1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m828.37,366.33c-3.5,0-4.43-3.19-4.43-4.87v-66.55l-4.38-1.19c-1.74-.48-2.92-1.32-3.4-2.45-.4-.95-.29-2.01.33-3.16,1.27-2.33,5.47-7.67,10.71-13.62,4.85-5.51,14.58-13.71,14.68-13.79l.86,1.02c-.1.08-9.76,8.22-14.54,13.65-5.18,5.88-9.31,11.13-10.54,13.38-.42.77-.51,1.45-.28,2,.31.73,1.21,1.32,2.52,1.68l5.36,1.46v67.57c0,.36.11,3.54,3.1,3.54s3.09-3.18,3.1-3.54l.45-67.86,4.32.81-.24,1.31-2.76-.52-.44,66.26c0,1.68-.93,4.87-4.43,4.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m918.18,213l-1.33-.09.05-.66c.23-3.36.72-10.34-.82-12.65-1.32-1.98-8.44-3.66-11.07-4.14l.24-1.31c1.02.19,10.07,1.9,11.94,4.71,1.79,2.68,1.3,9.71,1.04,13.48l-.04.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m904.24,252.35v-1.33c3.02,0,5.88-2.49,7.11-6.18,1.3-3.89,3.28-15.71,3.3-15.83l1.31.22c-.08.49-2.02,12.05-3.34,16.04-1.42,4.24-4.78,7.1-8.38,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m922.39,366.33c-3.5,0-4.43-3.19-4.43-4.87l-.44-66.26-2.76.52-.24-1.31,4.32-.81.45,67.86c0,.36.11,3.54,3.1,3.54s3.09-3.18,3.1-3.54v-67.57l5.36-1.46c1.32-.36,2.22-.96,2.52-1.68.24-.56.14-1.23-.28-2-1.22-2.25-5.36-7.5-10.54-13.38-4.78-5.43-15.92-14.44-16.03-14.53l.84-1.04c.46.37,11.34,9.17,16.19,14.69,5.24,5.95,9.44,11.3,10.71,13.62.63,1.15.74,2.21.33,3.16-.48,1.13-1.66,1.97-3.4,2.45l-4.38,1.19v66.55c0,1.69-.93,4.87-4.43,4.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m873.52,298.83c-5.29,0-10.65-.66-10.71-.67l.17-1.32c.05,0,5.33.66,10.54.66s14.47-.66,14.56-.66l.1,1.33c-.09,0-9.38.67-14.65.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m713.96,363.04l4.53-4.44c.63-.54,1.45-.72,2.17-.09.36.36,5.62,5.07,11.69,5.07s10.51-4.98,10.51-10.69-3.81-10.15-10.96-10.15h-13.95c-1.81,0-2.81-1.72-2.81-3.17v-26.73c0-.91.72-1.72,1.72-1.72h28.64c1,0,1.72.82,1.72,1.72v6.16c0,.91-.72,1.72-1.72,1.72h-20.12v12.05h7.79c12.87,0,20.75,8.24,20.75,20.12s-9.42,20.75-21.93,20.75c-9.7,0-15.59-4.8-17.85-7.52-1.18-1.36-1.27-1.99-.18-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m759,370.11l11.78-15.86-11.42-15.13c-.91-1.18-.18-2.63,1.36-2.63h7.52c1.18,0,2.17.09,2.99,1.27l5.89,8.52h.09l5.98-8.52c.72-1,1.45-1.27,2.72-1.27h8.16c1.54,0,1.99,1.45,1.09,2.63l-11.42,15.04,11.51,15.95c.82,1.18.36,2.63-1.09,2.63h-7.97c-1.18,0-1.9-.54-2.54-1.45l-6.43-9.06h-.09l-6.89,9.79c-.27.36-1,.72-1.45.72h-8.7c-1.54,0-1.9-1.45-1.09-2.63Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-36",
    transform: "translate(34.42 67.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEP 1:")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 31.18
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.49,
    y: 31.18
  }, "hoose a suitable chai"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 226.3,
    y: 31.18
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 234.57,
    y: 31.18
  }, ".")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 0,
    y: 61.07
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.36,
    y: 61.07
  }, "he heig"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 64.37,
    y: 61.07
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.21,
    y: 61.07
  }, "t of the chair should ")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 84.45
  }, "be app"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 49.97,
    y: 84.45
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 56.46,
    y: 84.45
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.62,
    y: 84.45
  }, "x. 43cm."))), /*#__PURE__*/React.createElement("text", {
    className: "cls-36",
    transform: "translate(529.92 58.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEP 2:")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 0,
    y: 31.18
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.98,
    y: 31.18
  }, "se a timer to time yourself ")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 62.36
  }, "doing the "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 102.43,
    y: 62.36
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 116.13,
    y: 62.36
  }, "tand4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 178.18,
    y: 62.36
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.87,
    y: 62.36
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 200.84,
    y: 62.36
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.62,
    y: 62.36
  }, "ength ")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 93.55
  }, "challenge.")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 123.43
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.29,
    y: 123.43
  }, "it-to-stand on both legs 5 times with ")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 146.82
  }, "arms folded as fast as you can."))), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 487.49,
    y1: 41.26,
    x2: 487.49,
    y2: 391.58
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAu);
export default __webpack_public_path__ + "static/media/ic_AU.51ea4af2338c67b008a4e8ec898bac0c.svg";
export { ForwardRef as ReactComponent };